export default __webpack_public_path__ + "static/media/complementary--trucks-go-right--g1.82ab3332.png";